import DayPart from "../../day-part";
import DayPartHelper from "../day-part-helper";

class DayPartDaily extends DayPart {
  constructor(props) {
    super(props);
    this._helper = new DayPartHelper(props, "days");
  }
}

export default DayPartDaily;
